import { rgb2hex } from './Utils';

/* eslint-disable */

//#region jquery extensions

$.fn.changeElementType = function (newType) {
    var attrs = {};
    var element = this[0];
    if (element != undefined) {
        $.each(element.attributes, function (idx, attr) {
            attrs[attr.nodeName] = attr.nodeValue;
        });
    }
    this.replaceWith(function () {
        return $('<' + newType + '/>', attrs).append($(this).contents());
    });
};

$.fn.pressEnter = function (fn) {
    return this.each(function () {
        $(this).bind('enterPress', fn);
        $(this).keyup(function (e) {
            if (e.keyCode == 13 || e.keyCode == 10) {
                $(this).trigger('enterPress');
            }
        });
    });
};

$.fn.removeEmptyAnchorTags = function (fn) {
    var anchors = $(this).find('a');
    $.each(anchors, function (index, value) {
        if (!$(value).attr('href')) {
            $(value).children('.unwrappable').unwrap();
        }
    });
};

$.fn.getHexBackgroundColor = function () {
    return (function (rgb) {
        return '#' + (!rgb ? 'FFFFFF' : rgb2hex(rgb));
    })($(this).css('background-color'));
};

//#endregion

